import React from 'react';
import { SURFACE_POWER_OUTPUT_ROWS } from '../../constants/latest-asset-trend.constant';
import GenericEspWidget from './GenericEspWidget';

const SurfacePowerOutputWidget: React.FC = () => (
  <GenericEspWidget title='Surface power output' rowsConfig={SURFACE_POWER_OUTPUT_ROWS} />
);

export default SurfacePowerOutputWidget;
